<template>
  <div class="cont">
    <!-- <div class="title" :class="title_object">
      {{ curData.name }}
    </div> -->
    <div class="clear">
      <el-image style="width: 100%; " v-show="curData.src1" :src="curData.src1" fit="contain"></el-image>
    </div>

  </div>
</template>

<script>
export default {
  name: "ContOne",
  data() {
    return {
      fit: "contain",
      id: '',
      pageData: {
        EC型: {
          name: 'EC型',
          src1: require('@/assets/image/variousproducts/brakePadsDetail/EC.png'),
          src2: require('@/assets/image/variousproducts/brakePadsDetail/EC型/img2.png'),
          src3: require('@/assets/image/variousproducts/brakePadsDetail/EC型/img3.png'),
          src4: require('@/assets/image/variousproducts/brakePadsDetail/EC型/img4.png'),
          src5: require('@/assets/image/variousproducts/brakePadsDetail/EC型/img5.png'),
          src6: require('@/assets/image/variousproducts/brakePadsDetail/EC型/img6.png'),
          src7: require('@/assets/image/variousproducts/brakePadsDetail/EC型/img7.png'),
          src8: require('@/assets/image/variousproducts/brakePadsDetail/EC型/img8.png'),
          src9: require('@/assets/image/variousproducts/brakePadsDetail/EC型/img9.png'),
          src10: require('@/assets/image/variousproducts/brakePadsDetail/EC型/img10.png'),
          src11: require('@/assets/image/variousproducts/brakePadsDetail/EC型/img11.png'),
          src12: require('@/assets/image/variousproducts/brakePadsDetail/EC型/img12.png'),
          src13: require('@/assets/image/variousproducts/brakePadsDetail/EC型/img13.png'),
        },
        ES型: {
          name: 'ES型',
          src1: require('@/assets/image/variousproducts/brakePadsDetail/ES.png'),
          src2: require('@/assets/image/variousproducts/brakePadsDetail/ES型/img2.png'),
          src3: require('@/assets/image/variousproducts/brakePadsDetail/ES型/img3.png'),
          src4: require('@/assets/image/variousproducts/brakePadsDetail/ES型/img4.png'),
          src5: require('@/assets/image/variousproducts/brakePadsDetail/ES型/img5.png'),
          src6: require('@/assets/image/variousproducts/brakePadsDetail/ES型/img6.png'),
          src7: require('@/assets/image/variousproducts/brakePadsDetail/ES型/img7.png'),
          src8: require('@/assets/image/variousproducts/brakePadsDetail/ES型/img8.png'),
          src9: require('@/assets/image/variousproducts/brakePadsDetail/ES型/img9.png'),
          src10: require('@/assets/image/variousproducts/brakePadsDetail/ES型/img10.png'),
          src11: require('@/assets/image/variousproducts/brakePadsDetail/ES型/img11.png'),
          src12: require('@/assets/image/variousproducts/brakePadsDetail/ES型/img12.png'),
        },
        M型: {
          name: 'M型',
          src1: require('@/assets/image/variousproducts/brakePadsDetail/M.png'),
          src2: require('@/assets/image/variousproducts/brakePadsDetail/M型/img2.png'),
          src3: require('@/assets/image/variousproducts/brakePadsDetail/M型/img3.png'),
          src4: require('@/assets/image/variousproducts/brakePadsDetail/M型/img4.png'),
          src5: require('@/assets/image/variousproducts/brakePadsDetail/M型/img5.png'),
          src6: require('@/assets/image/variousproducts/brakePadsDetail/M型/img6.png'),
          src7: require('@/assets/image/variousproducts/brakePadsDetail/M型/img7.png'),
          src8: require('@/assets/image/variousproducts/brakePadsDetail/M型/img8.png'),
          src9: require('@/assets/image/variousproducts/brakePadsDetail/M型/img9.png'),
          src10: require('@/assets/image/variousproducts/brakePadsDetail/M型/img10.png'),
          src11: require('@/assets/image/variousproducts/brakePadsDetail/M型/img11.png'),
          src12: require('@/assets/image/variousproducts/brakePadsDetail/M型/img12.png'),
          src13: require('@/assets/image/variousproducts/brakePadsDetail/M型/img13.png'),
          src14: require('@/assets/image/variousproducts/brakePadsDetail/M型/img14.png'),
          src15: require('@/assets/image/variousproducts/brakePadsDetail/M型/img15.png'),

        },
        Premium型: {
          name: 'P型',
          src1: require('@/assets/image/variousproducts/brakePadsDetail/P.png'),
          src2: require('@/assets/image/variousproducts/brakePadsDetail/Premium型/img2.png'),
          src3: require('@/assets/image/variousproducts/brakePadsDetail/Premium型/img3.png'),
          src4: require('@/assets/image/variousproducts/brakePadsDetail/Premium型/img4.png'),
          src5: require('@/assets/image/variousproducts/brakePadsDetail/Premium型/img5.png'),
          src6: require('@/assets/image/variousproducts/brakePadsDetail/Premium型/img6.png'),
          src7: require('@/assets/image/variousproducts/brakePadsDetail/Premium型/img7.png'),
          src8: require('@/assets/image/variousproducts/brakePadsDetail/Premium型/img8.png'),
          src9: require('@/assets/image/variousproducts/brakePadsDetail/Premium型/img9.png'),
          src10: require('@/assets/image/variousproducts/brakePadsDetail/Premium型/img10.png'),
          src11: require('@/assets/image/variousproducts/brakePadsDetail/Premium型/img11.png'),
          src12: require('@/assets/image/variousproducts/brakePadsDetail/Premium型/img12.png'),
          src13: require('@/assets/image/variousproducts/brakePadsDetail/Premium型/img13.png'),
          src14: require('@/assets/image/variousproducts/brakePadsDetail/Premium型/img14.png'),
          src15: require('@/assets/image/variousproducts/brakePadsDetail/Premium型/img15.png'),
          src16: require('@/assets/image/variousproducts/brakePadsDetail/Premium型/img16.png'),
          src17: require('@/assets/image/variousproducts/brakePadsDetail/Premium型/img17.png'),
          src18: require('@/assets/image/variousproducts/brakePadsDetail/Premium型/img18.png'),
        },
        R01型: {
          name: 'R系列',
          src1: require('@/assets/image/variousproducts/brakePadsDetail/R01.png'),
          src2: require('@/assets/image/variousproducts/brakePadsDetail/RN型/img2.png'),
          src3: require('@/assets/image/variousproducts/brakePadsDetail/RN型/img3.png'),
          src4: require('@/assets/image/variousproducts/brakePadsDetail/RN型/img4.png'),
          src5: require('@/assets/image/variousproducts/brakePadsDetail/RN型/img5.png'),
          src6: require('@/assets/image/variousproducts/brakePadsDetail/RN型/img6.png'),
          src7: require('@/assets/image/variousproducts/brakePadsDetail/RN型/img7.png'),
          src8: require('@/assets/image/variousproducts/brakePadsDetail/RN型/img8.png'),
          src9: require('@/assets/image/variousproducts/brakePadsDetail/RN型/img9.png'),
          src10: require('@/assets/image/variousproducts/brakePadsDetail/RN型/img10.png'),
        },
        RA型: {
          name: 'R系列',
          src1: require('@/assets/image/variousproducts/brakePadsDetail/RA.png'),
          src2: require('@/assets/image/variousproducts/brakePadsDetail/RN型/img2.png'),
          src3: require('@/assets/image/variousproducts/brakePadsDetail/RN型/img3.png'),
          src4: require('@/assets/image/variousproducts/brakePadsDetail/RN型/img4.png'),
          src5: require('@/assets/image/variousproducts/brakePadsDetail/RN型/img5.png'),
          src6: require('@/assets/image/variousproducts/brakePadsDetail/RN型/img6.png'),
          src7: require('@/assets/image/variousproducts/brakePadsDetail/RN型/img7.png'),
          src8: require('@/assets/image/variousproducts/brakePadsDetail/RN型/img8.png'),
          src9: require('@/assets/image/variousproducts/brakePadsDetail/RN型/img9.png'),
          src10: require('@/assets/image/variousproducts/brakePadsDetail/RN型/img10.png'),
        },
        RD型: {
          name: 'R系列',
          src1: require('@/assets/image/variousproducts/brakePadsDetail/RD.png'),
          src2: require('@/assets/image/variousproducts/brakePadsDetail/RN型/img2.png'),
          src3: require('@/assets/image/variousproducts/brakePadsDetail/RN型/img3.png'),
          src4: require('@/assets/image/variousproducts/brakePadsDetail/RN型/img4.png'),
          src5: require('@/assets/image/variousproducts/brakePadsDetail/RN型/img5.png'),
          src6: require('@/assets/image/variousproducts/brakePadsDetail/RN型/img6.png'),
          src7: require('@/assets/image/variousproducts/brakePadsDetail/RN型/img7.png'),
          src8: require('@/assets/image/variousproducts/brakePadsDetail/RN型/img8.png'),
          src9: require('@/assets/image/variousproducts/brakePadsDetail/RN型/img9.png'),
          src10: require('@/assets/image/variousproducts/brakePadsDetail/RN型/img10.png'),
        },
        RE型: {
          name: 'R系列',
          src1: require('@/assets/image/variousproducts/brakePadsDetail/RE.png'),
          src2: require('@/assets/image/variousproducts/brakePadsDetail/RN型/img2.png'),
          src3: require('@/assets/image/variousproducts/brakePadsDetail/RN型/img3.png'),
          src4: require('@/assets/image/variousproducts/brakePadsDetail/RN型/img4.png'),
          src5: require('@/assets/image/variousproducts/brakePadsDetail/RN型/img5.png'),
          src6: require('@/assets/image/variousproducts/brakePadsDetail/RN型/img6.png'),
          src7: require('@/assets/image/variousproducts/brakePadsDetail/RN型/img7.png'),
          src8: require('@/assets/image/variousproducts/brakePadsDetail/RN型/img8.png'),
          src9: require('@/assets/image/variousproducts/brakePadsDetail/RN型/img9.png'),
          src10: require('@/assets/image/variousproducts/brakePadsDetail/RN型/img10.png'),
        },
        RGM型: {
          name: 'R系列',
          src1: require('@/assets/image/variousproducts/brakePadsDetail/RGM.png'),
          src2: require('@/assets/image/variousproducts/brakePadsDetail/RN型/img2.png'),
          src3: require('@/assets/image/variousproducts/brakePadsDetail/RN型/img3.png'),
          src4: require('@/assets/image/variousproducts/brakePadsDetail/RN型/img4.png'),
          src5: require('@/assets/image/variousproducts/brakePadsDetail/RN型/img5.png'),
          src6: require('@/assets/image/variousproducts/brakePadsDetail/RN型/img6.png'),
          src7: require('@/assets/image/variousproducts/brakePadsDetail/RN型/img7.png'),
          src8: require('@/assets/image/variousproducts/brakePadsDetail/RN型/img8.png'),
          src9: require('@/assets/image/variousproducts/brakePadsDetail/RN型/img9.png'),
          src10: require('@/assets/image/variousproducts/brakePadsDetail/RN型/img10.png'),
        },
        RGS型: {
          name: 'R系列',
          src1: require('@/assets/image/variousproducts/brakePadsDetail/RGS.png'),
          src2: require('@/assets/image/variousproducts/brakePadsDetail/RN型/img2.png'),
          src3: require('@/assets/image/variousproducts/brakePadsDetail/RN型/img3.png'),
          src4: require('@/assets/image/variousproducts/brakePadsDetail/RN型/img4.png'),
          src5: require('@/assets/image/variousproducts/brakePadsDetail/RN型/img5.png'),
          src6: require('@/assets/image/variousproducts/brakePadsDetail/RN型/img6.png'),
          src7: require('@/assets/image/variousproducts/brakePadsDetail/RN型/img7.png'),
          src8: require('@/assets/image/variousproducts/brakePadsDetail/RN型/img8.png'),
          src9: require('@/assets/image/variousproducts/brakePadsDetail/RN型/img9.png'),
          src10: require('@/assets/image/variousproducts/brakePadsDetail/RN型/img10.png'),
        },
        RGX型: {
          name: 'R系列',
          src1: require('@/assets/image/variousproducts/brakePadsDetail/RGX.png'),
          src2: require('@/assets/image/variousproducts/brakePadsDetail/RGX型/img2.png'),
          src3: require('@/assets/image/variousproducts/brakePadsDetail/RGX型/img3.png'),
          src4: require('@/assets/image/variousproducts/brakePadsDetail/RGX型/img4.png'),
          src5: require('@/assets/image/variousproducts/brakePadsDetail/RGX型/img5.png'),
          src6: require('@/assets/image/variousproducts/brakePadsDetail/RGX型/img6.png'),
          src7: require('@/assets/image/variousproducts/brakePadsDetail/RGX型/img7.png'),
          src8: require('@/assets/image/variousproducts/brakePadsDetail/RGX型/img8.png'),
          src9: require('@/assets/image/variousproducts/brakePadsDetail/RGX型/img9.png'),
          src10: require('@/assets/image/variousproducts/brakePadsDetail/RGX型/img10.png'),
          src11: require('@/assets/image/variousproducts/brakePadsDetail/RGX型/img11.png'),
          src12: require('@/assets/image/variousproducts/brakePadsDetail/RGX型/img12.png'),
          src13: require('@/assets/image/variousproducts/brakePadsDetail/RGX型/img13.png'),
          src14: require('@/assets/image/variousproducts/brakePadsDetail/RGX型/img14.png'),
          src15: require('@/assets/image/variousproducts/brakePadsDetail/RGX型/img15.png'),
          src16: require('@/assets/image/variousproducts/brakePadsDetail/RGX型/img16.png'),
        },
        RN型: {
          name: 'R系列',
          src1: require('@/assets/image/variousproducts/brakePadsDetail/RN.png'),
          src2: require('@/assets/image/variousproducts/brakePadsDetail/RN型/img2.png'),
          src3: require('@/assets/image/variousproducts/brakePadsDetail/RN型/img3.png'),
          src4: require('@/assets/image/variousproducts/brakePadsDetail/RN型/img4.png'),
          src5: require('@/assets/image/variousproducts/brakePadsDetail/RN型/img5.png'),
          src6: require('@/assets/image/variousproducts/brakePadsDetail/RN型/img6.png'),
          src7: require('@/assets/image/variousproducts/brakePadsDetail/RN型/img7.png'),
          src8: require('@/assets/image/variousproducts/brakePadsDetail/RN型/img8.png'),
          src9: require('@/assets/image/variousproducts/brakePadsDetail/RN型/img9.png'),
          src10: require('@/assets/image/variousproducts/brakePadsDetail/RN型/img10.png'),
        },
        Specom_GT: {
          name: 'SPECOM系列',
          src1: require('@/assets/image/variousproducts/brakePadsDetail/Specom-GT.png'),
          src2: require('@/assets/image/variousproducts/brakePadsDetail/Specom型/img2.png'),
          src3: require('@/assets/image/variousproducts/brakePadsDetail/Specom型/img3.png'),
          src4: require('@/assets/image/variousproducts/brakePadsDetail/Specom型/img4.png'),
          src5: require('@/assets/image/variousproducts/brakePadsDetail/Specom型/img5.png'),
          src6: require('@/assets/image/variousproducts/brakePadsDetail/Specom型/img6.png'),
          src7: require('@/assets/image/variousproducts/brakePadsDetail/Specom型/img7.png'),
          src8: require('@/assets/image/variousproducts/brakePadsDetail/Specom型/img8.png'),
          src9: require('@/assets/image/variousproducts/brakePadsDetail/Specom型/img9.png'),
        },
        Specom_K: {
          name: 'SPECOM系列',
          src1: require('@/assets/image/variousproducts/brakePadsDetail/ES.png'),
          src2: require('@/assets/image/variousproducts/brakePadsDetail/Specom型/img2.png'),
          src3: require('@/assets/image/variousproducts/brakePadsDetail/Specom型/img3.png'),
          src4: require('@/assets/image/variousproducts/brakePadsDetail/Specom型/img4.png'),
          src5: require('@/assets/image/variousproducts/brakePadsDetail/Specom型/img5.png'),
          src6: require('@/assets/image/variousproducts/brakePadsDetail/Specom型/img6.png'),
          src7: require('@/assets/image/variousproducts/brakePadsDetail/Specom型/img7.png'),
          src8: require('@/assets/image/variousproducts/brakePadsDetail/Specom型/img8.png'),
          src9: require('@/assets/image/variousproducts/brakePadsDetail/Specom型/img9.png'),
        },
        Specom_α: {
          name: 'SPECOM系列',
          src1: require('@/assets/image/variousproducts/brakePadsDetail/Specom-α.png'),
          src2: require('@/assets/image/variousproducts/brakePadsDetail/Specom型/img2.png'),
          src3: require('@/assets/image/variousproducts/brakePadsDetail/Specom型/img3.png'),
          src4: require('@/assets/image/variousproducts/brakePadsDetail/Specom型/img4.png'),
          src5: require('@/assets/image/variousproducts/brakePadsDetail/Specom型/img5.png'),
          src6: require('@/assets/image/variousproducts/brakePadsDetail/Specom型/img6.png'),
          src7: require('@/assets/image/variousproducts/brakePadsDetail/Specom型/img7.png'),
          src8: require('@/assets/image/variousproducts/brakePadsDetail/Specom型/img8.png'),
          src9: require('@/assets/image/variousproducts/brakePadsDetail/Specom型/img9.png'),
        },
        Specom_β: {
          name: 'SPECOM系列',
          src1: require('@/assets/image/variousproducts/brakePadsDetail/Specom-β.png'),
          src2: require('@/assets/image/variousproducts/brakePadsDetail/Specom型/img2.png'),
          src3: require('@/assets/image/variousproducts/brakePadsDetail/Specom型/img3.png'),
          src4: require('@/assets/image/variousproducts/brakePadsDetail/Specom型/img4.png'),
          src5: require('@/assets/image/variousproducts/brakePadsDetail/Specom型/img5.png'),
          src6: require('@/assets/image/variousproducts/brakePadsDetail/Specom型/img6.png'),
          src7: require('@/assets/image/variousproducts/brakePadsDetail/Specom型/img7.png'),
          src8: require('@/assets/image/variousproducts/brakePadsDetail/Specom型/img8.png'),
          src9: require('@/assets/image/variousproducts/brakePadsDetail/Specom型/img9.png'),
        },
        X型: {
          name: 'X型',
          src1: require('@/assets/image/variousproducts/brakePadsDetail/X.png'),
          src2: require('@/assets/image/variousproducts/brakePadsDetail/RGX型/img2.png'),
          src3: require('@/assets/image/variousproducts/brakePadsDetail/RGX型/img3.png'),
          src4: require('@/assets/image/variousproducts/brakePadsDetail/RGX型/img4.png'),
          src5: require('@/assets/image/variousproducts/brakePadsDetail/RGX型/img5.png'),
          src6: require('@/assets/image/variousproducts/brakePadsDetail/RGX型/img6.png'),
          src7: require('@/assets/image/variousproducts/brakePadsDetail/RGX型/img7.png'),
          src8: require('@/assets/image/variousproducts/brakePadsDetail/RGX型/img8.png'),
          src9: require('@/assets/image/variousproducts/brakePadsDetail/RGX型/img9.png'),
          src10: require('@/assets/image/variousproducts/brakePadsDetail/RGX型/img10.png'),
          src11: require('@/assets/image/variousproducts/brakePadsDetail/RGX型/img11.png'),
          src12: require('@/assets/image/variousproducts/brakePadsDetail/RGX型/img12.png'),
          src13: require('@/assets/image/variousproducts/brakePadsDetail/RGX型/img13.png'),
          src14: require('@/assets/image/variousproducts/brakePadsDetail/RGX型/img14.png'),
          src15: require('@/assets/image/variousproducts/brakePadsDetail/RGX型/img15.png'),
          src16: require('@/assets/image/variousproducts/brakePadsDetail/RGX型/img16.png'),

        },
        Z型: {
          name: 'Z型',
          src1: require('@/assets/image/variousproducts/brakePadsDetail/Z.png'),
          src2: require('@/assets/image/variousproducts/brakePadsDetail/Z型/img2.png'),
          src3: require('@/assets/image/variousproducts/brakePadsDetail/Z型/img3.png'),
          src4: require('@/assets/image/variousproducts/brakePadsDetail/Z型/img4.png'),
          src5: require('@/assets/image/variousproducts/brakePadsDetail/Z型/img5.png'),
          src6: require('@/assets/image/variousproducts/brakePadsDetail/Z型/img6.png'),
          src7: require('@/assets/image/variousproducts/brakePadsDetail/Z型/img7.png'),
          src8: require('@/assets/image/variousproducts/brakePadsDetail/Z型/img8.png'),
          src9: require('@/assets/image/variousproducts/brakePadsDetail/Z型/img9.png'),
          src10: require('@/assets/image/variousproducts/brakePadsDetail/Z型/img10.png'),
          src11: require('@/assets/image/variousproducts/brakePadsDetail/Z型/img11.png'),
          src12: require('@/assets/image/variousproducts/brakePadsDetail/Z型/img12.png'),
          src13: require('@/assets/image/variousproducts/brakePadsDetail/Z型/img13.png'),
        },
        S型: {
          name: 'S型',
          src1: require('@/assets/image/variousproducts/brakePadsDetail/S.png'),
          src2: require('@/assets/image/variousproducts/brakePadsDetail/S型/2.png'),
          src3: require('@/assets/image/variousproducts/brakePadsDetail/S型/3.png'),
          src4: require('@/assets/image/variousproducts/brakePadsDetail/S型/4.png'),
          src5: require('@/assets/image/variousproducts/brakePadsDetail/S型/5.png'),
          src6: require('@/assets/image/variousproducts/brakePadsDetail/S型/6.png'),
          src7: require('@/assets/image/variousproducts/brakePadsDetail/S型/7.png'),
          src8: require('@/assets/image/variousproducts/brakePadsDetail/S型/8.png'),
          src9: require('@/assets/image/variousproducts/brakePadsDetail/S型/9.png'),
          src10: require('@/assets/image/variousproducts/brakePadsDetail/S型/10.png'),
          src11: require('@/assets/image/variousproducts/brakePadsDetail/S型/11.png'),
        }


      },
      curData: {}
    };
  },
  computed: {
    title_object: function () {
      return {
        "t_Premium": this.curData.name == 'Premium型',
        't_RGX': this.curData.name == 'RGM型' || this.curData.name == 'X型' || this.curData.name == 'X/RGX型',
        't_specom': this.curData.name == 'SPECOM系列' || this.curData.name == 'Specom-K' || this.curData.name == 'Specom-α' || this.curData.name == 'Specom-β'
      }
    },
  },
  methods: {
    getData() {
      let id = this.id
      this.curData = this.pageData[id]
      console.log(this.curData)
      this.$nextTick(() => {

        if (id == 'RA型' || id == 'R01型') {
          document.getElementById("RA4").scrollIntoView({ block: "center" });
        } else if (id == 'RN型') {
          document.getElementById("RN7").scrollIntoView({ block: "center" });
        } else if (id == 'RD型') {
          document.getElementById("RD9").scrollIntoView({ block: "center" });
        } else if (id == 'RE型') {

        } else if (id == 'RGM型') {   //RGM10
          document.getElementById("RGM10").scrollIntoView({ block: "center" });
        } else if (id == 'RGS型') {
          document.getElementById("RGS8").scrollIntoView({ block: "center" });
        } else if (id == 'Specom_GT') {
          document.getElementById("Specom_cont").scrollIntoView({ block: "start" });
        } else if (id == 'Specom_α' || id == 'Specom_β') {
          document.getElementById("Specom_cont").scrollIntoView({ block: "center" });
        } else if (id == 'Specom_K') {
          document.getElementById("Specom_cont").scrollIntoView({ block: "end" });
        }

        //Specom_cont
      })


    }
  },
  created() {
    this.id = this.$route.params.id
    this.getData()
  },
  watch: {
    $route(to) {
      // 对路由变化作出响应...
      // console.log( to.params.id )
      this.id = to.params.id
      this.getData()

      // console.log( from )
    }
  }

};
</script>

<style lang="stylus" scoped>
.cont {
  width: 1003px;
  background-color: #fff;
  margin: 0 auto;
  padding: 62px 73px;
  box-sizing: border-box;
  position relative
}

.clear{
  position: relative
}
.clear:after {
  display: block;
  clear: both;
  content: '';
}

.title {
  position: absolute;
  width: 170px;
  height: 108px;
  left: 66px;
  top: -68px;
  background: url('~@/assets/image/variousproducts/brakeOil/img21.png');
  background-repeat: no-repeat;
  background-size: cover;
  padding: 41px 42px 39px 42px;
  box-sizing: border-box;
  font-size:30px
  color:#fff;
  text-align :center
}
.t_Premium{
  background: url('~@/assets/image/variousproducts/brakePadsDetail/Premium型/img1.png');
  width:256px;
}
.t_RGX {
  background: url('~@/assets/image/variousproducts/brakePadsDetail/RGM型/img1.png');
  width:196px;
  padding: 26px 31px 18px 42px
}
.t_specom {
  width: 204px ;
  padding: 21px 40px 20px 50px
}

.title_name {
  width: 86px;
  height: 28px;
  background: url('~@/assets/image/variousproducts/brakeOil/img22.png');
  background-repeat: no-repeat;
  background-size: contain;
}



</style>
